import { PurchaseRequestRecord, RequestLineRecord } from '../../../../types/PurchaseRequest';
import { RecordFile } from '../../../../types';
import React, { useMemo, useState } from 'react';
import AttachmentUpload from '../../../../components/AttachmentUpload';
import PurchaseRequestInfoView from './PurchaseRequestInfoView';
import PurchaseRequestInfoTable from './PurchaseRequestInfoTable';
import { Input, Space } from 'antd';

interface PurchaseRequestInfoContentProp {
  data?: PurchaseRequestRecord;
  attachments: RecordFile[] | undefined;
  /** Set together to allow adding/removing; omit any and the list stays read-only. */
  api?: string;
  recordId?: string;
  canEdit?: boolean;
}

const { Search } = Input;

const PurchaseRequestInfoContent: React.FC<PurchaseRequestInfoContentProp> = ({
  data,
  attachments,
  api,
  recordId,
  canEdit,
}) => {
  const [searchText, setSearchText] = useState('');

  const filteredRequestLines = useMemo(() => {
    if (!data?.requestLines || !searchText) {
      return data?.requestLines || [];
    }

    const lowercasedSearchText = searchText.toLowerCase();

    const searchFields: (keyof RequestLineRecord | 'product' | 'productUom')[] = [
      'proder', 'pono', 'sku', 'description', 'product', 'productUom'
    ];

    return data.requestLines.filter(line =>
      searchFields.some((field) => {
        const value = line[field];

        if (typeof value === 'string') {
          return value.toLowerCase().includes(lowercasedSearchText);
        }

        if (field === 'product' && line.product?.code) {
          return line.product.code.toLowerCase().includes(lowercasedSearchText);
        }

        if (field === 'productUom' && line.productUom?.description) {
          return line.productUom.description.toLowerCase().includes(lowercasedSearchText);
        }

        return false;
      })
    );
  }, [data?.requestLines, searchText]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  return (
    <>
      <div className={'w-9/12 space-y-4 h-[calc(84vh)] overflow-auto m'}>
        <div className={'p-4 rounded'}>
          <PurchaseRequestInfoView data={data} />
          <AttachmentUpload
          attachments={attachments}
          api={api}
          recordId={recordId}
          canEdit={canEdit}
        />
          <div className={'py-4 flex justify-between'}>
            <span className={'text-base font-semibold leading-6'}>
              Request Lines
            </span>

            <Space direction="horizontal" size={12}>
              <Search
                placeholder="Search"
                value={searchText}
                allowClear
                onSearch={handleSearch}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Space>
          </div>
          <PurchaseRequestInfoTable requestLines={filteredRequestLines} />
        </div>
      </div>
    </>
  );
};

export default PurchaseRequestInfoContent;
